module.exports = __webpack_public_path__ + "static/media/totalOrders.2ae5cca4.svg";